import { render, staticRenderFns } from "./DocutaxSubmissionStatusEdit.vue?vue&type=template&id=7bb97582&"
import script from "./DocutaxSubmissionStatusEdit.vue?vue&type=script&lang=js&"
export * from "./DocutaxSubmissionStatusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports